import { gql } from '@apollo/client'

const ADD_NEW_REFERRAL_SUB_SOURCE = gql`
  mutation ADD_NEW_REFERRAL_SUB_SOURCE(
    $generatedID: ID!
    $referralSource: ID!
    $name: String!
    $order: Int
    $color: String!
    $referralUrl: String
    $referralId: String
  ) {
    addNewReferralSubSource(
      generatedID: $generatedID
      referralSource: $referralSource
      name: $name
      order: $order
      color: $color
      referralUrl: $referralUrl
      referralId: $referralId
    ) {
      id
      name
      order
      color
      referralUrl
      referralId
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default ADD_NEW_REFERRAL_SUB_SOURCE
